import { useRef } from "react";
import useReveal from "@/hooks/useReveal";
import useCounter from "@/hooks/useCounter";

function Stat({ value, suffix = "", label, sub, decimals = 0, testid }) {
  const [ref, current] = useCounter(value, 2000, decimals);
  const display =
    decimals > 0
      ? current.toFixed(decimals).replace(".", ",")
      : Math.round(current).toLocaleString("de-DE");
  return (
    <div
      ref={ref}
      data-testid={testid}
      className="reveal text-center md:text-left"
    >
      <div className="flex items-baseline gap-1 justify-center md:justify-start">
        <span className="font-display text-5xl md:text-6xl text-[var(--niko-gold)] tabular-nums">
          {display}
        </span>
        {suffix && (
          <span className="font-display text-3xl md:text-4xl text-[var(--niko-gold)]">
            {suffix}
          </span>
        )}
      </div>
      <p className="mt-3 text-white text-sm font-medium tracking-wide">
        {label}
      </p>
      <p className="text-white/55 text-xs mt-1">{sub}</p>
    </div>
  );
}

export default function StatsBar() {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <section
      id="stats"
      ref={ref}
      data-testid="stats-section"
      className="relative bg-[var(--niko-dark)] text-white py-20 md:py-24 overflow-hidden"
    >
      <div className="grain pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
        <Stat
          value={943}
          suffix="+"
          label="Zufriedene Gäste"
          sub="auf Google bewertet"
          testid="stat-guests"
        />
        <Stat
          value={4.7}
          decimals={1}
          suffix="★"
          label="Google Bewertung"
          sub="von 5 Sternen"
          testid="stat-rating"
        />
        <Stat
          value={44}
          suffix=" Jahre"
          label="in Bochum-Höntrop"
          sub="Familientradition"
          testid="stat-years"
        />
        <div className="reveal text-center md:text-left" data-testid="stat-fresh">
          <div className="font-display text-5xl md:text-6xl text-[var(--niko-gold)]">
            Täglich
          </div>
          <p className="mt-3 text-white text-sm font-medium tracking-wide">
            frisch zubereitet
          </p>
          <p className="text-white/55 text-xs mt-1">aus der Küche</p>
        </div>
      </div>
    </section>
  );
}
